.root {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  flex: 0 0 136px;
  gap: 2px;
  max-width: 136px;
  min-width: 136px;
  width: 136px;
}

.trigger {
  border-radius: 999px;
  height: 44px;
  padding: 0 12px;
  width: 100%;

  &:hover {
    border-color: var(--color-foreground);
  }
}

.icon {
  height: 16px;
  width: 16px;
}

.error {
  max-width: 136px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
